import { render } from "./AppInstallPrompt.vue?vue&type=template&id=94f7cf2a"
import script from "./AppInstallPrompt.vue?vue&type=script&lang=js"
export * from "./AppInstallPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__